import React, { Component } from 'react';
import PropTypes from 'prop-types';
// import moment from 'moment';

// import BuyTimetable from './timetable';
import BuyScheme from './scheme';
// import BuyCheckout from './checkout';
import Popup from '../popup';
import getAuth from '../../helpers/get-auth';

import isBlankString from '../../helpers/is-blank-string';
import { setCookie, getCookie, monthTimeout } from '../../helpers/cookie';

// testData
// import testSession from './testData/session';
// import testUser from './testData/user';

class ShowScheme extends Component {
  static propTypes = {
    session: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
      .isRequired,
    route: PropTypes.shape({
      user: PropTypes.string,
      session: PropTypes.string,
      places: PropTypes.string,
      balance: PropTypes.string,
      buy: PropTypes.string,
      geo: PropTypes.string,
    }).isRequired,
  };

  constructor(props) {
    super(props);

    this.state = {
      id: props.session,
      wait: 0,
      loading: true,
      user: null,
      session: {},
      places: [],
      avatar: [],
      selected: [],
      errors: [],
      key: 0,
      exit: null,
      session_id: null,
      openTown: false,
      ask: false,
      screen: 1,
    };
  }

  componentDidMount() {
    const { session } = this.props;
    // const exit = testSession.full.data.hall.levels[0].objects;
    // const { width, height } = testSession.data;
    // this.setState({
    //   openTown: false,
    //   ask: false,
    //   id: session,
    //   wait: this.state.wait + 1,
    //   session: testSession.data,
    //   places: testSession.data.places,
    //   order: testSession.order,
    //   noBonus: testSession.data.cinema.no_bonus,
    //   order_success: testSession.order_success,
    //   errors: [],
    //   key: this.state.key + 1,
    //   selected: [],
    //   exit: this.getExit(width, height, exit),
    //   is_disabled: testSession.data.disabled,
    //   user: testUser.data,
    //   loading: false,
    // });
    this.loadSession(session);
    this.loadUser();
    this.loadGeo();
  }

  // getExit = (width, height, obj) => {
  //   const getPercent = (num, fullSum) => Math.round(100 / (num / fullSum));
  //   const percentOfX = getPercent(width, obj.x);
  //   const percentOfY = getPercent(height, obj.y);

  //   // Проверяем значение по Х
  //   if (percentOfX < 20) {
  //     obj.x = -25;
  //   }

  //   if (percentOfX > 80) {
  //     obj.x = width - 25;
  //   }

  //   if (percentOfY < 20) {
  //     obj.y = -25;
  //   }

  //   if (percentOfY > 80) {
  //     obj.y = height - 25;
  //   }

  //   return obj;
  // };

  loadGeo() {
    const askCity = getCookie('askCity');
    const date = askCity ? Number(askCity) : 0;
    const today = Date.now();
    let dif = 0;

    if (askCity) {
      dif = (today - date) / 1000 / 3600;
    }

    if (!askCity || dif > 48) {
      const { route } = this.props;

      const headers = {
        headers: {
          Accept: 'application/json',
        },
        method: 'GET',
      };

      fetch(route.geo, headers)
        .then(response => response.json())
        .then(json => {
          if (json.status == 'success') {
            if (!(json.data.validate == 'Y')) {
              this.setState({
                openTown: true,
              });
            }
          } else {
            this.setState({
              openTown: true,
            });
          }

          this.setState({
            ask: true,
          });
        })
        .catch(error => {
          this.setState({
            openTown: true,
            ask: true,
          });
        });
    }
  }

  // Загружаем пользователя
  loadUser() {
    const { route } = this.props;

    if (!this.state.loading) {
      this.setState({
        loading: true,
      });
    }

    const headers = {
      headers: {
        Accept: 'application/json',
      },
      method: 'GET',
    };

    // Фикс авторизации
    if (process.env.NODE_ENV != 'dev') {
      headers.credentials = 'include';
    } else {
      headers.headers.authorization = getAuth();
    }

    fetch(route.user, headers)
      .then(response => response.json())
      .then(json => {
        if (json.status == 'success') {
          this.setState({
            user: json.data,
            wait: this.state.wait + 1,
          });
        } else {
          this.setState({
            wait: this.state.wait + 1,
          });
        }

        setTimeout(() => {
          this.checkLoad();
        }, 10);
      })
      .catch(() => {
        this.setState({
          wait: this.state.wait + 1,
        });

        setTimeout(() => {
          this.checkLoad();
        }, 10);
      });
  }

  // Загружаем сеанс
  loadSession(id) {
    const { route } = this.props;

    if (!this.state.loading) {
      this.setState({
        loading: true,
      });
    }

    const headers = {
      headers: {
        Accept: 'application/json',
      },
      method: 'GET',
    };

    fetch(`${route.session}?id=${id}`, headers)
      .then(response => response.json())
      .then(json => {
        if (json.status === 'success') {
          const exit = json.data.enters[0];
          // const { width, height } = json.data;

          this.setState({
            id,
            wait: this.state.wait + 1,
            session: json.data,
            places: json.data.places,
            order: json.order,
            session_id: json.order_success.session_id,
            order_success: json.order_success,
            errors: [],
            // exit: this.getExit(width, height, exit),
            exit,
            key: this.state.key + 1,
            selected: [],
          });
          this.loadAvatars(json.order_success.session_id);
        } else {
          this.setState({
            id,
            wait: this.state.wait + 1,
            errors: json.errors,
            key: this.state.key + 1,
          });
        }

        setTimeout(() => {
          this.checkLoad();
        }, 10);
      })
      .catch(err => {
        this.setState({
          wait: this.state.wait + 1,
          key: this.state.key + 1,
          errors: [
            {
              detail: 'Ошибка получения сеанса.',
            },
          ],
        });

        setTimeout(() => {
          this.checkLoad();
        }, 10);
      });
  }

  // Получаем аватарки юзеров
  loadAvatars(id) {
    const { route } = this.props;

    if (!this.state.loading) {
      this.setState({
        loading: true,
      });
    }

    const headers = {
      headers: {
        Accept: 'application/json',
      },
      method: 'GET',
    };

    fetch(`${route.avatar}?id=${id}`, headers)
      .then(response => response.json())
      .then(json => {
        if (json.status == 'success') {
          this.setState({
            avatar: json.data,
          });
        } else {
          this.setState({
            wait: this.state.wait + 1,
            errors: json.errors,
            key: this.state.key + 1,
          });
        }

        setTimeout(() => {
          this.checkLoad();
        }, 10);
      })
      .catch(err => {
        this.setState({
          wait: this.state.wait + 1,
          key: this.state.key + 1,
          errors: [
            {
              detail: 'Ошибка получения сеанса.',
            },
          ],
        });

        setTimeout(() => {
          this.checkLoad();
        }, 10);
      });
  }

  // Проверка что загрузилось
  checkLoad() {
    const { wait } = this.state;

    if (wait >= 2) {
      this.setState({
        loading: false,
      });
    }
  }

  // Проверка не куплено ли
  checkSelected(id = null) {
    // Prepare places array for check
    const newSelected = this.state.selected;

    if (id != null) {
      if (newSelected.indexOf(id) !== -1) {
        newSelected.splice(newSelected.indexOf(id), 1);
      } else {
        if (newSelected.length < 8) {
          newSelected.push(id);
        }
      }
    }

    if (newSelected.length != 0) {
      const headers = {
        headers: {
          Accept: 'application/json',
        },
        method: 'GET',
      };

      fetch(this.props.route.places + '?id=' + this.state.id, headers)
        .then(response => {
          return response.json();
        })
        .then(json => {
          const available = json.available;
          // let found = newSelected.filter(p => available.includes(p));
          const found = newSelected.filter(p => available.indexOf(p) !== -1);

          this.setState({
            selected: found,
            places: json.places,
          });
        });
    } else {
      this.setState({ selected: [] });
    }
  }

  // Считаем стоимость
  calcAmount() {
    let amount = 0;
    // let selectedPlaces = this.state.places.filter(p => this.state.selected.includes(p.id));
    const selectedPlaces = this.state.places.filter(
      p => this.state.selected.indexOf(p.id) !== -1,
    );

    selectedPlaces.forEach(p => {
      amount += p.price;
    });
    return amount;
  }

  // Открыть попап выбора города
  openTownPicker() {
    const { ask } = this.state;

    if (ask) {
      setCookie('askCity', `${Date.now()}`, monthTimeout);
    }

    $.magnificPopup.open({
      items: {
        src: '#town-picker',
      },
      removalDelay: 250,
      callbacks: {
        beforeOpen() {
          this.st.mainClass = 'mfp-anim';
        },
      },
    });
  }

  toggleTown() {
    const { openTown, ask } = this.state;

    if (ask) {
      setCookie('askCity', `${Date.now()}`, monthTimeout);
    }

    this.setState({
      openTown: !openTown,
      ask: false,
    });
  }

  // Переход между шагами
  toggleScreen() {
    this.setState({
      screen: this.state.screen == 1 ? 2 : 1,
    });
  }

  render() {
    const {
      loading,
      errors,
      key,
      // openTown,
      screen,
      order,
      order_success,
      avatar,
      // exit,
    } = this.state;
    const close = (
      <svg viewBox="0 0 18 18" width="18" height="18">
        <path d="M15.5 17.6l-6.5-6.5-6.5 6.5c-.6.6-1.5.6-2.1 0-.6-.6-.6-1.5 0-2.1l6.5-6.5-6.5-6.5c-.6-.6-.6-1.5 0-2.1.6-.6 1.5-.6 2.1 0l6.5 6.5 6.5-6.5c.6-.6 1.5-.6 2.1 0 .6.6.6 1.5 0 2.1l-6.5 6.5 6.5 6.5c.6.6.6 1.5 0 2.1-.3.3-.6.4-1 .4s-.8-.2-1.1-.4z" />
      </svg>
    );

    if (loading)
      return (
        <div className="popup popup--loading">
          <button className="popup__close" type="button">
            {close}
          </button>
        </div>
      );

    const s = this.state.session;

    if (errors.length)
      return (
        <Popup
          type="alert"
          status="error"
          title="Ошибка"
          message={`${errors[0].detail ||
            'Ошибка получения сеанса.'} Попробуйте еще раз.`}
          button="Назад"
        />
      );

    const date = s.datetime;
    const day = date.split(' ')[0];
    const time = date.split(' ')[1];

    const amount = this.calcAmount();
    const { user } = this.state;

    let total = null;

    if (amount > 0) {
      total = (
        <div className="scheme-box__total">
          <button
            className="btn btn--accent"
            type="button"
            onClick={this.toggleScreen}
          >
            Оформить заказ на {amount} руб.
          </button>
        </div>
      );
    }

    let hall = s.hall.replace(/[^\d\.]/g, '');

    if (isBlankString(hall)) {
      hall = s.hall;
    } else {
      hall = `Зал ${hall}`;
    }

    const ord =
      order && order.seats.length && !isBlankString(order.payment_link);

    return (
      <div
        key={key}
        className="scheme-popup scheme-popup--watch"
        data-step={screen}
      >
        <div className="scheme-popup__select">
          <div className="scheme-popup__header">
            <button className="scheme-popup__close" type="button">
              {close}
            </button>
            <h3 className="heading heading--2"> {s.film.name}</h3>
            <div className="title-meta">
              <div className="title-meta__item">
                <div className="town">
                  <span className="town__sub-txt">{`${s.cinema.name}, ${s.cinema.address}`}</span>
                </div>
              </div>
              <span className="title-meta__item">{hall}</span>
              <span className="title-meta__item">{`${day.split('-')[2]}.${
                day.split('-')[1]
              }.${day.split('-')[0]}, ${time.split(':')[0]}:${
                time.split(':')[1]
              }`}</span>
            </div>
          </div>
          <div className="scheme-popup__scheme scheme-box">
            <BuyScheme
              session={this.state.id}
              selected={this.state.selected}
              width={s.width}
              height={s.height}
              places={this.state.places}
              onSelectPlace={id => this.checkSelected(id)}
              order={order}
              exit={this.state.exit}
              avatar={avatar}
              order_success={order_success}
              disable={
                order &&
                order.seats.length &&
                !isBlankString(order.payment_link)
              }
            />
            {ord ? null : total}
            {ord && user && user.user_id ? (
              <p className="scheme-box__note scheme-box__note--show">
                У вас есть неоплаченный заказ. Вы&nbsp;можете{' '}
                <a href={order.payment_link}>оплатить&nbsp;его</a> или отменить
                заказ в&nbsp;<a href="/profile">личном&nbsp;кабинете</a>
              </p>
            ) : user ? null : (
              <p className="scheme-box__note">
                Для начисления и&nbsp;оплаты бонусами{' '}
                <a href="/login">авторизуйтесь</a>. Бонусы на&nbsp;кассе
                не&nbsp;начисляются.
              </p>
            )}
          </div>
        </div>
      </div>
    );
  }
}

export default ShowScheme;
